angular.module('myApp')

.factory('commonAuthFactory', ['$routeParams', '$sessionStorage', 'commonFactory', 'Const',
function ($routeParams, $sessionStorage, commonFactory, Const) {
  this.$sessionStorage = $sessionStorage;
  this.commonFactory = commonFactory;
  /**
   * switch dev, prod cognito setting for user(staff)
   */
  this.configureUserCognito = () => {
    // host名取得
    let hostname = window.location.hostname;
    if (hostname === Const.PROD_HOST_NAME) {
      this.userPoolIdUser = Const.PROD_USER_COGNITO_USER_POOL_ID;
      this.clientIdUser = Const.PROD_USER_CLIENT_ID;
      this.identityPoolIdUser = Const.PROD_USER_COGNITO_ID_POOL_ID;
    } else {
      this.userPoolIdUser = Const.DEV_USER_COGNITO_USER_POOL_ID;
      this.clientIdUser = Const.DEV_USER_CLIENT_ID;
      this.identityPoolIdUser = Const.DEV_USER_COGNITO_ID_POOL_ID;
    }
  };

  this.configureStaffCognito = () => {
    // host名取得
    let hostname = window.location.hostname;
    if (hostname === Const.PROD_HOST_NAME) {
      this.userPoolIdUser = Const.PROD_STAFF_COGNITO_USER_POOL_ID;
      this.clientIdUser = Const.PROD_STAFF_CLIENT_ID;
      this.identityPoolIdUser = Const.PROD_STAFF_COGNITO_ID_POOL_ID;
    } else {
      this.userPoolIdUser = Const.DEV_STAFF_COGNITO_USER_POOL_ID;
      this.clientIdUser = Const.DEV_STAFF_CLIENT_ID;
      this.identityPoolIdUser = Const.DEV_STAFF_COGNITO_ID_POOL_ID;
    }
  };

  /**
   * UserIDとパスワードを使いユーザ認証を行い、CognitoからTemporary Credentialsを取得する
   * 認証に成功した場合はPromiseでCredentialsを返す
   */
  this.userLogin = (userId, userPassword, newPassword) => {
    return new Promise((resolve, reject) => {
      this.configureUserCognito();
      let authenticationData = {
        Username: userId,
        Password: userPassword
      };
      let authenticationDetails = new AWSCognito
        .CognitoIdentityServiceProvider.AuthenticationDetails(authenticationData);
      let poolData = {
        UserPoolId: this.userPoolIdUser,
        ClientId: this.clientIdUser,
        Paranoia: 7
      };
      let userPool =
        new AWSCognito.CognitoIdentityServiceProvider.CognitoUserPool(poolData);
      let userData = {
        Username: userId,
        Pool: userPool
      };
      let cognitoUser =
        new AWSCognito.CognitoIdentityServiceProvider.CognitoUser(userData);

      // ユーザ認証を行う
      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: (authresult) => {
          let jwtToken = authresult.getIdToken().getJwtToken();
          let refreshToken = authresult.getRefreshToken().getToken();
          let accessToken = authresult.getAccessToken().getJwtToken();
          // ユーザ認証で得たIDTokenを元にTemporary Credentialsを取得する
          getCredentials(jwtToken, (error, value) => {
            if (error) {
              return reject(error);
            }
            localStorage.setItem(Const.LSKEY_USER_ID, userId);
            localStorage.setItem(Const.LSKEY_USER_ID_TOKEN, jwtToken);
            localStorage.setItem(Const.LSKEY_USER_REFRESH_TOKEN, refreshToken);
            localStorage.setItem(Const.LSKEY_USER_ACCESS_TOKEN, accessToken);
            return resolve(value);
          });
        },
        onFailure: (err) => {
          return reject(err);
        },

        // 仮パスワードの場合
        newPasswordRequired: (userAttributes, requiredAttributes) => {
          localStorage.setItem(Const.LSKEY_USER_ID, userId);
          // 新しいパスワードがあれば、パスワードを変更
          if (newPassword != null) {
            let attributeData = null;
            cognitoUser.completeNewPasswordChallenge(newPassword, attributeData, {
              onSuccess: (authresult) => {
                let jwtToken = authresult.getIdToken().getJwtToken();
                let accessToken = authresult.getAccessToken().getJwtToken();
                let refreshToken = authresult.getRefreshToken().getToken();
                // ユーザ認証で得たIDTokenを元にTemporary Credentialsを取得する
                getCredentials(jwtToken, (error, value) => {
                  if (error) { return reject(error); }
                  localStorage.setItem(Const.LSKEY_USER_ID_TOKEN, jwtToken);
                  localStorage.setItem(Const.LSKEY_USER_REFRESH_TOKEN, refreshToken);
                  localStorage.setItem(Const.LSKEY_USER_ACCESS_TOKEN, accessToken);
                  return resolve(value);
                });
              },
              onFailure: (err) => {
                return reject(err);
              }
            });
          } else {
            // 新しいパスワードが未入力の場合、パスワード変更画面に遷移
            this.$sessionStorage[Const.SSAPP_IS_TMP_PASSWORD] = true;
            this.$sessionStorage[Const.SSAPP_IS_LOADING] = false;
            location.href = '#/password_change';
          }
        }
      });
    });
  };

  /*
   * パスワードを変更する
   */
  this.changePassword = (oldPassword, newPassword) => {
    return new Promise((resolve, reject) => {
      if (localStorage.getItem(Const.LSAPP_ROLE) === Const.LSAPP_ROLE_MEMBER) {
        this.configureUserCognito();
      } else {
        this.configureStaffCognito();
      }
      let userId = localStorage.getItem(Const.LSKEY_USER_ID);
      let poolData = {
        UserPoolId: this.userPoolIdUser,
        ClientId: this.clientIdUser,
        Paranoia: 7
      };
      let userPool = new AWSCognito.CognitoIdentityServiceProvider.CognitoUserPool(poolData);
      let userData = {
        Username: userId,
        Pool: userPool
      };
      let cognitoUser = new AWSCognito.CognitoIdentityServiceProvider.CognitoUser(userData);
      cognitoUser.signInUserSession = cognitoUser.getCognitoUserSession({
        IdToken: localStorage.getItem(Const.LSKEY_USER_ID_TOKEN),
        AccessToken: localStorage.getItem(Const.LSKEY_USER_ACCESS_TOKEN),
        RefreshToken: localStorage.getItem(Const.LSKEY_USER_REFRESH_TOKEN)
      });

      cognitoUser.changePassword(oldPassword, newPassword, (err, result) => {
        if (err) { return reject(err); }
        return resolve();
      });
    });
  };

  /**
   * IDTokenを元にCognitoからTemporary Credentialsを取得する
   */
  this.staffLogin = (userId, userPassword, newPassword) => {
    return new Promise((resolve, reject) => {
      this.configureStaffCognito();
      let authenticationData = {
        Username: userId,
        Password: userPassword
      };
      let authenticationDetails = new AWSCognito
        .CognitoIdentityServiceProvider.AuthenticationDetails(authenticationData);
      let poolData = {
        UserPoolId: this.userPoolIdUser,
        ClientId: this.clientIdUser,
        Paranoia: 7
      };
      let userPool =
        new AWSCognito.CognitoIdentityServiceProvider.CognitoUserPool(poolData);
      let userData = {
        Username: userId,
        Pool: userPool
      };
      let cognitoUser =
        new AWSCognito.CognitoIdentityServiceProvider.CognitoUser(userData);

      // ユーザ認証を行う
      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: function (authresult) {
          let jwtToken = authresult.getIdToken().getJwtToken();
          let refreshToken = authresult.getRefreshToken().getToken();
          let accessToken = authresult.getAccessToken().getJwtToken();
          // ユーザ認証で得たIDTokenを元にTemporary Credentialsを取得する
          getCredentials(jwtToken, (error, value) => {
            if (error) {
              return reject(error);
            }
            localStorage.setItem(Const.LSKEY_USER_ID, userId);
            localStorage.setItem(Const.LSKEY_USER_ID_TOKEN, jwtToken);
            localStorage.setItem(Const.LSKEY_USER_REFRESH_TOKEN, refreshToken);
            localStorage.setItem(Const.LSKEY_USER_ACCESS_TOKEN, accessToken);
            return resolve(value);
          });
        },
        onFailure: function (err) {
          return reject(err);
        },

        // 仮パスワードの場合
        newPasswordRequired: (userAttributes, requiredAttributes) => {
          localStorage.setItem(Const.LSKEY_USER_ID, userId);
          // 新しいパスワードがあれば、パスワードを変更
          if (newPassword != null) {
            let attributeData = null;
            cognitoUser.completeNewPasswordChallenge(newPassword, attributeData, {
              onSuccess: (authresult) => {
                let jwtToken = authresult.getIdToken().getJwtToken();
                let accessToken = authresult.getAccessToken().getJwtToken();
                let refreshToken = authresult.getRefreshToken().getToken();
                // ユーザ認証で得たIDTokenを元にTemporary Credentialsを取得する
                getCredentials(jwtToken, (error, value) => {
                  if (error) { return reject(error); }
                  localStorage.setItem(Const.LSKEY_USER_ID_TOKEN, jwtToken);
                  localStorage.setItem(Const.LSKEY_USER_REFRESH_TOKEN, refreshToken);
                  localStorage.setItem(Const.LSKEY_USER_ACCESS_TOKEN, accessToken);
                  return resolve(value);
                });
              },
              onFailure: (err) => {
                return reject(err);
              }
            });
          } else {
            // 新しいパスワードが未入力の場合、パスワード変更画面に遷移
            this.$sessionStorage[Const.SSAPP_IS_TMP_PASSWORD] = true;
            this.$sessionStorage[Const.SSAPP_IS_LOADING] = false;
            location.href = '#/password_change';
          }
        }
      });
    });
  };

  /**
   * IDTokenを元にCognitoからTemporary Credentialsを取得する
   */
  let getCredentials = (jwtToken, callback) => {
    let loginStr =
      'cognito-idp.' + Const.REGION + '.amazonaws.com/' + this.userPoolIdUser;
    let identityObj = {};
    identityObj = {
      IdentityPoolId: this.identityPoolIdUser,
      Logins: {}
    };
    identityObj.Logins[loginStr] = jwtToken;
    AWS.config.region = Const.REGION;
    AWS.config.credentials = new AWS.CognitoIdentityCredentials(identityObj);
    AWS.config.credentials.clearCachedId();
    AWS.config.credentials.get(err => {
      if (err) {
        callback(err, null);
        return;
      }
      let accessKeyId = AWS.config.credentials.accessKeyId;
      let secretAccessKey = AWS.config.credentials.secretAccessKey;
      let sessionToken = AWS.config.credentials.sessionToken;
      callback(null, {
        accessKeyId: accessKeyId,
        secretAccessKey: secretAccessKey,
        sessionToken: sessionToken
      });
    });
  };

  /**
   * ユーザ認証で得たTemporary Credentialsにより、
   * FunctionAPIの実行権限が付与されたCredentialsを取得する
   * PromiseでCredentialsが返る
   */
  this.getCredentialsForAPI = (credentials, role) => new Promise((resolve, reject) => {
    if (!credentials) {
      return reject('Please authenticate.');
    }
    let accessKeyId = credentials.accessKeyId;
    let secretAccessKey = credentials.secretAccessKey;
    let sessionToken = credentials.sessionToken;
    let apigClient = apigClientFactory.newClient({
      'accessKey': accessKeyId,
      'secretKey': secretAccessKey,
      'sessionToken': sessionToken,
      'region': Const.REGION
    });
    let body;
    let params;
    if (role === Const.LSAPP_ROLE_MEMBER) {
      params = { role: Const.LSAPP_ROLE_MEMBER };
    } else {
      params = { role: Const.LSAPP_ROLE_STAFF };
    }
    apigClient.roleAuthorizationPost(params, body, {})
      .then((result) => {
        let credentials = result.data;
        localStorage.setItem(Const.LSKEY_USER_ACCESS_KEY_ID, credentials.AccessKeyId);
        localStorage.setItem(Const.LSKEY_USER_SECRET_ACCESS_KEY, credentials.SecretAccessKey);
        localStorage.setItem(Const.LSKEY_USER_SESSION_TOKEN, credentials.SessionToken);
        return resolve();
      }).catch(result => {
        if (result.response) {
          if (result.response.status === 503) {
            this.commonFactory.flashErrorMessageFlag(Const.SSAPP_HAS_MAINTENANCE_ERROR, 5000, true);
          }
        }
        let errorRes = JSON.stringify(result);
        return reject(errorRes);
      });
  });

  /**
   * RefreshTokenを使いIDTokenを取得し、CognitoからTemporary Credentialsを取得する
   * PromiseでCredentialsを返す
   */
  this.refreshCredentials = () => {
    return new Promise((resolve, reject) => {
      let userRefreshToken = localStorage.getItem(Const.LSKEY_USER_REFRESH_TOKEN);
      let userId = localStorage.getItem(Const.LSKEY_USER_ID);
      let refreshToken =
        new AWSCognito.CognitoIdentityServiceProvider.CognitoRefreshToken({
          RefreshToken: userRefreshToken
        });
      if (localStorage.getItem(Const.LSAPP_ROLE) === Const.LSAPP_ROLE_MEMBER) {
        this.configureUserCognito();
      } else {
        this.configureStaffCognito();
      }
      let poolData = {
        UserPoolId: this.userPoolIdUser,
        ClientId: this.clientIdUser,
        Paranoia: 7
      };
      let userPool =
        new AWSCognito.CognitoIdentityServiceProvider.CognitoUserPool(poolData);
      let userData = {
        Username: userId,
        Pool: userPool
      };
      let cognitoUser =
        new AWSCognito.CognitoIdentityServiceProvider.CognitoUser(userData);
      cognitoUser.refreshSession(refreshToken, (err, authresult) => {
        if (err) {
          console.log(err);
          return reject(err);
        }
        let jwtToken = authresult.getIdToken().getJwtToken();
        let refreshToken = authresult.getRefreshToken().getToken();

        // refreshで得たIDTokenを元にTemporary Credentialsを取得する
        getCredentials(jwtToken, (error, value) => {
          if (error) {
            console.log(error);
            return reject(error);
          }
          localStorage.setItem(Const.LSKEY_USER_REFRESH_TOKEN, refreshToken);
          return resolve(value);
        });
      });
    });
  };

  return this;
}]);



// WEBPACK FOOTER //
// ./app/lib/common-auth.es6